import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box
} from '@mui/material';
import { useEffect } from 'react';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';
import IllustrationWrapper from '../../../../v3/Illustrration/IllustrationWrapper';
import DeleteSvg from '../../../../v3/Illustrration/components/DeleteSvg';
import { CustomButton } from '../../../MUI_custom_component';

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  isNominee = false
}) => {
  const userData = useSelector(state => state.user?.userData);

  // Track modal load event when modal opens
  useEffect(() => {
    if (open) {
      if (isNominee) {
        trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_LOAD', {
          manufacturer_id: userData?.manufacturer_id || '',
          modal_type: 'delete_nominee'
        });
      } else {
        trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_LOAD', {
          manufacturer_id: userData?.manufacturer_id || '',
          modal_type: 'delete_beneficiary'
        });
      }
    }
  }, [open, isNominee, userData?.manufacturer_id]);

  const handleCancelClick = () => {
    // Track modal close event
    if (isNominee) {
      trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_CLOSE', {
        manufacturer_id: userData?.manufacturer_id || '',
        modal_type: 'delete_nominee',
        action: 'cancel'
      });
    } else {
      trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_CLOSE', {
        manufacturer_id: userData?.manufacturer_id || '',
        modal_type: 'delete_beneficiary',
        action: 'cancel'
      });
    }
    
    trackAnalyticsEvent('BENEFICIARY_DELETE_CANCEL_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      delete_type: isNominee ? 'nominee' : 'beneficiary',
      action: 'cancel'
    });
    onClose();
  };

  const handleDeleteClick = () => {
    if (isNominee) {
      trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        action: 'confirm_delete_nominee'
      });
    } else {
      trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        action: 'confirm_delete_beneficiary'
      });
      
      trackAnalyticsEvent('BENEFICIARY_DELETE_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        delete_type: 'beneficiary',
        action: 'confirm_delete'
      });
    }
    onConfirm();
  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
          sx: { borderRadius: 2, textAlign: 'center',  width: 400, p: 2 , m: 0, gap: 4}
      }}
    >
      <Box sx={{ textAlign: 'center'}}>
          <IllustrationWrapper 
            illustration={<DeleteSvg />}
            title="Are you sure you want to delete?"
            subtitle="This action cannot be undone. All data would be lost?"
          />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <CustomButton
            variant="filled"
            color="primary"
            label="No"
            onClick={handleCancelClick}
            sx={{ width: '100%' }}
          />
          <CustomButton
            variant="outlined"
            color="primary"
            label="Yes"
            onClick={handleDeleteClick}
            disabled={loading}
            loading={loading}
            sx={{ width: '100%' }}
          />
      </Box>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
